<template>
  <v-container>
    <v-col v-for="(symptom, index) in model.symptoms" :key="index" dense>
      <v-row>
        <v-col cols="6" lg="6" md="6" sm="12">
          <v-banner
            color="blue-grey lighten-5"
            class="br mr-3 black--text"
            single-line
            align="center"
          >
            <strong>{{ symptom.name }}:</strong><br />
          </v-banner>
        </v-col>

        <v-col
          cols="3"
          lg="3"
          md="3"
          sm="6"
          class="pa-0"
          v-for="(ears, index) in bothEars"
          :key="index"
        >
          <v-checkbox
            :label="ears.name"
            :value="ears.idBodyPart"
            v-model="symptom.bodyParts"
            :disabled="isViewDetailsForm"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {
  props: {
    model: Object,
    isViewDetailsForm: Boolean,
    bothEars: Array,
  },
  data() {
    return {};
  },
  created() {},
};
</script>

<style>
.v-data-table__wrapper {
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>
